import { configureStore } from "@reduxjs/toolkit";
import { formReducer } from "./reducer";

export function createSubscriptionStore() {
	return configureStore({
		reducer: formReducer(),
	});
}
